import React from "react";
import styles from "./Styles.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const Hint = ({
  hint,
  clouse,
  current,
  route,
  isCurrentStep,
  setIsCurrentStep,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <section className={styles.hint_container}>
        <div>
          <h2>{hint.title}</h2>
          <p>{hint.description}</p>
          {route == "/alpha-adrenoblocker" ? ( // для конкретного пациента
            <ul>
              {hint.list.map((element, index) => {
                return <li key={index}>{element}</li>;
              })}
            </ul>
          ) : (
            <>
              {hint.list.map((element, index) => {
                return <div key={index}>{element}</div>;
              })}
            </>
          )}

          <br />
          <img src={hint.image} alt="" />
          <p>{hint.footer}</p>
        </div>
      </section>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* <div className="buttonBack" onClick={() => clouse(null)}>
          Назад
        </div> */}
        <button
          style={{ margin: "0 auto" }}
          onClick={() => {
            let check = true;
            for (let i in current) {
              if (current[i].isCorrectVariant) {
                if (!current[i].isChecked) check = false;
              } else {
                if (current[i].isChecked) check = false;
              }
            }
            if (isCurrentStep && check) {
              setIsCurrentStep(false);
              navigate(route);
            } else clouse(null);
          }}
          className="buttonBack"
        >
          Ок
        </button>
      </div>
    </>
  );
};

export default Hint;
